import { Component, Inject, Prop, Watch,BaseMixins } from '@/lib';
import HiBase from "@/components/form/hi-base.vue";
@Component({ components: { HiBase } })
export class FormComponentBase extends BaseMixins {
    @Prop({ type: String, required: true }) labelKey: string; //多语言key
    @Prop({ type: Boolean, default: false }) required: boolean; //是否必填
    @Prop({ type: Boolean, default: false }) disabled: boolean; //是否disabled
    @Prop({ type: String, default: "8" }) span: string; //栅格size   
    @Prop({ type: Number, default: 0 }) offset: number; //左留白   
    @Prop({ type: Array, default: () => { return [] } }) rules: Array<any>; //validate
    @Prop({ type: Number}) labelWidth:number;
    @Prop({ type: String, required: false }) specifyPropName: string; //指定验证属性名称
    @Prop({ type: Boolean, default: true }) isShowLabel: boolean;

    @Inject({ from: 'modelValidateError',default:{error:null} }) _modelValidateError;

    /*服务端validate验证处理*/
    error = "";
    @Watch("_modelValidateError", { deep: true })
    watchValidateError() {
        this.error = ""
        this.$nextTick(() => {
            if (this._modelValidateError.error) {
                let errorMsg = this._modelValidateError.error[this.propName];
                if (errorMsg) this.error = errorMsg.split('_')[0];
            }
        });
    }

    get requiredRule() {
        return {
            required: true, //是否必填
            message: this.L("Validate.PleaseInput", this.L(this.labelKey)), //验证信息
            trigger: "blur" //触发方式    常用  blur 和 change}
        }
    }

    get propName() {
        if(this.specifyPropName) return this.specifyPropName;

        let arr = this.labelKey.split(".");
        let propName = arr.length > 1 ? arr[arr.length - 1] : arr[0];
        propName = propName.replace(propName[0], propName[0].toLowerCase());
        return propName;
    }
    
    get itemRules() {
        let result = [];
        if (this.required) {
            result.push(this.requiredRule);
        }
        result = result.concat(this.rules);
        return result;
    }
}